import React, {Component } from 'react';
import { Breadcrumb, Card, Spin,Badge, Space, Empty, Modal  } from 'antd';
import { DashboardOutlined, DollarOutlined, FilePptOutlined,FileDoneOutlined,DoubleRightOutlined, ClockCircleOutlined  } from '@ant-design/icons';
import {Row, Col} from 'react-bootstrap';
import mDashboardControllers from './../../control/dashboard/index.controllers';
import mHelper from './../../config/Helper';
import HeaderTitle from '../../component/HeaderTitle/HeaderTitle';
import moment from 'moment';
var thisComponent;

class Dashboard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadingDashboard : false,
            Periode: mHelper.GET_DATE_DIGIPOS(),
            SHARE_BAR_A : 0,
            SHARE_BAR_B: 0,
            SHARE_INVOICE_BEFORE_SIGN: 0,
            SHARE_INVOICE_SIGN : 0,
            SHARE_FAKTUR_PAJAK: 0,
            SHARE_BUKPOT: 0,
            VALID_DISPUTE_PPOB_A: 0,
            REJECT_DISPUTE_PPOB_A: 0,
            VALID_DISPUTE_RECHARGE_A: 0,
            REJECT_DISPUTE_RECHARGE_A: 0,
            VALID_DISPUTE_RECHARGE_B: 0,
            REJECT_DISPUTE_RECHARGE_B: 0,
            FPJP_NOTA: 0,
            FPJP_INVOICE: 0,
            FPJP_NOTA_NOTE: {count: 0, raw: []},
            FPJP_INVOICE_NOTE: {count: 0, raw: []},
            ALERT : {count: 0, data: {}},
            SHOW_ALERT_INV : false,
            SHOW_ALERT_NOTA : false,
            formHide : true,
        };
        thisComponent = this;
    }


    async componentDidMount() {
        this.onRefreshDataDashboard();
    }

    onChangeDate = (date, dateString) => {
        this.setState({Periode:dateString});
        this.onHideCondition();
    }
    

    onProcessDashboard = () => {
        this.onRefreshDataDashboard();
        this.onHideCondition();
    }

    downloadDocInfo = () => {
        mDashboardControllers.GET_FILE_DOC({names:"SKB_PPH23_FINARYA_PERIODE_27_AGT31_DES_2021.pdf" },(r)=>{
            if(r.success == true){
                const buff = Buffer.from(r.data, "base64");
                const file = new Blob([buff],{type: 'application/pdf'});
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            }else{
                Modal.info({
                    title: 'Error',
                    content: (
                      <div>
                        <p>File tidak bisa ditemukan !</p>
                      </div>
                    ),
                    onOk() {},
                });
            }
        });
    }

    onHideCondition = () =>{
        var today = new Date(this.state.Periode+"-"+"01");
        var MonthNow  = (today.getMonth() + 1);
        var YearNow   = today.getFullYear();
        if(parseInt(MonthNow) >= 8 && parseInt(MonthNow) <= 12 && parseInt(YearNow) == 2021){
            this.setState({formHide:false});
        }else{
            this.setState({formHide:true});
        }
    }

    onRefreshDataDashboard = () => {
        this.setState({loadingDashboard: true});
        mDashboardControllers.READ_DASHBOARD(this.state.Periode,(r)=>{
            console.log(r);
            var show_inv = false;
            var show_nota = false;
            if(r.ALERT.count > 0){
                var rawAlert = r.ALERT.data;
                if(rawAlert.count != 0){
                    if(rawAlert.share_bar_b == 1 && rawAlert.share_inv == 1 &&  rawAlert.share_fp == 1 ){
                        if(rawAlert.submit_inv == 0){
                            show_inv  = true;
                        }
                    }

                    if(rawAlert.share_bar_a == 1 && rawAlert.share_bukpot == 1){
                        if(rawAlert.submit_nota == 0){
                            show_nota  = true;
                        }
                    }

                }
            }

            this.setState({
                loadingDashboard : false,
                SHARE_BAR_A : r.SHARE_BAR_A,
                SHARE_BAR_B: r.SHARE_BAR_B,
                SHARE_INVOICE_BEFORE_SIGN: r.SHARE_INVOICE_BEFORE_SIGN,
                SHARE_FAKTUR_PAJAK: r.SHARE_FAKTUR_PAJAK,
                SHARE_BUKPOT: r.SHARE_BUKPOT,
                VALID_DISPUTE_PPOB_A: r.VALID_DISPUTE_PPOB_A,
                REJECT_DISPUTE_PPOB_A: r.REJECT_DISPUTE_PPOB_A,
                VALID_DISPUTE_RECHARGE_A: r.VALID_DISPUTE_RECHARGE_A,
                REJECT_DISPUTE_RECHARGE_A: r.REJECT_DISPUTE_RECHARGE_A,
                VALID_DISPUTE_RECHARGE_B: r.VALID_DISPUTE_RECHARGE_B,
                REJECT_DISPUTE_RECHARGE_B: r.REJECT_DISPUTE_RECHARGE_B,
                FPJP_NOTA: r.FPJP_NOTA,
                FPJP_INVOICE: r.FPJP_INVOICE,
                FPJP_NOTA_NOTE: r.FPJP_NOTA_NOTE,
                FPJP_INVOICE_NOTE: r.FPJP_INVOICE_NOTE,
                SHARE_INVOICE_SIGN : r.SHARE_INVOICE_SIGN,
                ALERT : r.ALERT,
                SHOW_ALERT_INV : show_inv,
                SHOW_ALERT_NOTA : show_nota
            });
        })
    }

    render(){
        return (
            <div >
                <Breadcrumb>
                    <Breadcrumb.Item>
                    <div className="TitlePage">
                        <DashboardOutlined className="icon" /><DoubleRightOutlined className="iconArrow" /> <h3>Dashboard</h3>
                    </div>
                    </Breadcrumb.Item>
                </Breadcrumb>
                <Row style={this.state.formHide==true ? {display:"none"} : {display:"block"}}> 
                    <Col sm={12}  lg={12} style={{marginBottom:30}}>
                        <Card  bordered={false} className="box">
                            <Row>
                                <Col sm={12}>
                                    <Space>
                                        <div style={{marginLeft:30}}>
                                            Sehubungan dengan info dari Tax LinkAja mengenai Surat Keterangan Bebas PPh 23, maka untuk segala reimbursement PPh 23 dari Mitra AD Digipos untuk periode yg disebutkan akan ditiadakan. Chek Document : <a onClick={this.downloadDocInfo} style={{fontWeight:'bold'}}>Download Surat Keterangan Bebas (SKB).</a>
                                        </div>
                                    </Space>
                                </Col>
                            </Row>
                        </Card> 
                    </Col>
                </Row>
                {
                this.state.SHOW_ALERT_INV == true || this.state.SHOW_ALERT_NOTA == true ? 
                <Row> 
                    <Col sm={12}  lg={12} style={{marginBottom:30}}>
                        <Card  bordered={false} className="box">
                            <Row>
                                <Col sm={12} className="icon">
                                    <div style={{fontSize:"14px",fontWeight:"bold",textAlign:"left"}}> ALERT :</div>
                                </Col>
                                <Col sm={12}>
                                    <Space>
                                        { this.state.SHOW_ALERT_INV == true ?
                                        this.state.ALERT.data.level_inv < 0 ? <div><div style={{marginLeft:30}}>Waktu anda untuk mengupload invoice telah berakhir, harap lapor ke administrator, jika anda blum menguploadnya." </div></div>:
                                        <div>
                                              <div style={{marginLeft:30}}> Segera lakukan upload invoice, sisa waktu Anda untuk mengupload invoice adalah : {this.state.ALERT.data.level_inv} Days
                                        </div></div>
                                        :""
                                        }
                                    </Space>
                                </Col>
                                <Col sm={12}>
                                    <Space>
                                        { this.state.SHOW_ALERT_NOTA == true ?
                                        this.state.ALERT.data.level_nota < 0 ? <div> <div style={{marginLeft:30}}> Waktu anda untuk mengupload nota debit telah berakhir, harap lapor ke administrator, jika anda blum menguploadnya. </div> </div>:
                                        <div>
                                            <div style={{marginLeft:30}}>Segera lakukan upload nota debit, sisa waktu Anda untuk mengupload nota debit adalah : {this.state.ALERT.data.level_nota} Days
                                        </div></div> 
                                        :""
                                        }
                                    </Space>
                                </Col>

                            </Row>
                        </Card>
                    </Col>
                </Row> :  ""
                }
                
                <Row> 
                    <HeaderTitle onChangeDate={this.onChangeDate} onProcess={this.onProcessDashboard} momen={moment(this.state.Periode, 'YYYY-MM')}/>
                </Row>
                <Spin spinning={this.state.loadingDashboard} >
                    <Row> 
                        <Col sm={12}  lg={3} style={{marginBottom:30}}>
                            <Card  bordered={false} className="box">
                                <Row>
                                    <Col sm={2} className="icon">
                                        <h1><FileDoneOutlined className="blue-text" /> </h1>
                                    </Col>
                                    <Col sm={10}>
                                        <div className="box-title">DOCUMENT BAR AD A</div>
                                        <div className="box-count">{this.state.SHARE_BAR_A}</div>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col sm={12}  lg={3} style={{marginBottom:30}}>
                            <Card  bordered={false} className="box">
                                <Row>
                                    <Col sm={2} className="icon">
                                        <h1><FileDoneOutlined className="blue-text" /> </h1>
                                    </Col>
                                    <Col sm={10}>
                                        <div className="box-title">DOCUMENT BAR AD B</div>
                                        <div className="box-count">{this.state.SHARE_BAR_B}</div>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col sm={12}  lg={3} style={{marginBottom:30}}>
                            <Card  bordered={false} className="box">
                                <Row>
                                    <Col sm={2} className="icon">
                                        <h1><FileDoneOutlined className="blue-text" /> </h1>
                                    </Col>
                                    <Col sm={10}>
                                        <div className="box-title">DOCUMENT PAID INVOICE </div>
                                        <div className="box-count">{this.state.SHARE_INVOICE_BEFORE_SIGN}</div>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col sm={12}  lg={3} style={{marginBottom:30}}>
                            <Card  bordered={false} className="box">
                                <Row>
                                    <Col sm={2} className="icon">
                                        <h1><FileDoneOutlined className="blue-text" />  </h1>
                                    </Col>
                                    <Col sm={10}>
                                        <div className="box-title">DOCUMENT PAID INVOICE AFTER SIGN </div>
                                        <div className="box-count">{this.state.SHARE_INVOICE_SIGN}</div>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col sm={12}  lg={3} style={{marginBottom:30}}>
                            <Card  bordered={false} className="box">
                                <Row>
                                    <Col sm={2} className="icon">
                                        <h1><FileDoneOutlined className="blue-text" /> </h1>
                                    </Col>
                                    <Col sm={10}>
                                        <div className="box-title">DOCUMENT FAKTUR PAJAK </div>
                                        <div className="box-count">{this.state.SHARE_FAKTUR_PAJAK}</div>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col sm={12}  lg={3} style={{marginBottom:30}}>
                            <Card  bordered={false} className="box">
                                <Row>
                                    <Col sm={2} className="icon">
                                        <h1><FileDoneOutlined className="blue-text" /> </h1>
                                    </Col>
                                    <Col sm={10}>
                                        <div className="box-title"> DOCUMENT BUKTI POTONG </div>
                                        <div className="box-count">{this.state.SHARE_BUKPOT}</div>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col sm={12}  lg={3} style={{marginBottom:30}}>
                            <Card  bordered={false} className="box">
                                <Row>
                                    <Col sm={2} className="icon">
                                        <h1><FileDoneOutlined className="blue-text" /> </h1>
                                    </Col>
                                    <Col sm={10}>
                                        <div className="box-title"> DOCUMENT DISPUTE ACC </div>
                                        <div className="box-count">{(parseInt(this.state.VALID_DISPUTE_RECHARGE_A) + parseInt(this.state.VALID_DISPUTE_RECHARGE_B))}</div>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col sm={12}  lg={3} style={{marginBottom:30}}>
                            <Card  bordered={false} className="box">
                                <Row>
                                    <Col sm={2} className="icon">
                                        <h1><FileDoneOutlined className="blue-text" /> </h1>
                                    </Col>
                                    <Col sm={10}>
                                        <div className="box-title"> DOCUMENT DISPUTE REJECT </div>
                                        <div className="box-count">{(parseInt(this.state.REJECT_DISPUTE_RECHARGE_A) + parseInt(this.state.REJECT_DISPUTE_RECHARGE_B))}</div>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>

                        <Col sm={12}  lg={3} style={{marginBottom:30}}>
                            <Card  bordered={false} className="box">
                                <Row>
                                    <Col sm={2} className="icon">
                                        <h1><FileDoneOutlined className="blue-text" /> </h1>
                                    </Col>
                                    <Col sm={10}>
                                        <div className="box-title"> NOTA DEBET & UPLOAD</div>
                                        <div className="box-count">{parseInt(this.state.FPJP_NOTA)}</div>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>

                        <Col sm={12}  lg={3} style={{marginBottom:30}}>
                            <Card  bordered={false} className="box">
                                <Row>
                                    <Col sm={2} className="icon">
                                        <h1><FileDoneOutlined className="blue-text" /> </h1>
                                    </Col>
                                    <Col sm={10}>
                                        <div className="box-title"> NOTA DEBET & UPLOAD NOTE</div>
                                        <div className="box-count">{parseInt(this.state.FPJP_NOTA_NOTE.count)}</div>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>

                        <Col sm={12}  lg={3} style={{marginBottom:30}}>
                            <Card  bordered={false} className="box">
                                <Row>
                                    <Col sm={2} className="icon">
                                        <h1><FileDoneOutlined className="blue-text" /> </h1>
                                    </Col>
                                    <Col sm={10}>
                                        <div className="box-title"> INVOICE & UPLOAD</div>
                                        <div className="box-count">{parseInt(this.state.FPJP_INVOICE)}</div>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>

                        <Col sm={12}  lg={3} style={{marginBottom:30}}>
                            <Card  bordered={false} className="box">
                                <Row>
                                    <Col sm={2} className="icon">
                                        <h1><FileDoneOutlined className="blue-text" /> </h1>
                                    </Col>
                                    <Col sm={10}>
                                        <div className="box-title"> INVOICE & UPLOAD NOTE</div>
                                        <div className="box-count">{parseInt(this.state.FPJP_INVOICE_NOTE.count)}</div>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row>
                    <Row> 
                        <Col sm={12}  lg={12} style={{marginBottom:30}}>
                            <Card  bordered={false} className="box">
                                <Row>
                                    <Col sm={12} className="icon">
                                        <div style={{fontSize:"14px",fontWeight:"bold",textAlign:"left"}}> INFORMATION :</div>
                                    </Col>
                                    <Col sm={12}>
                                        {/* SHARE_INVOICE_SIGN */}
                                        {this.state.ALERT.count != 0 ?
                                        <div>
                                            {
                                                this.state.ALERT.data.share_bar_a != 0 ? 
                                                <div style={{fontSize:"12px",textAlign:"left"}}>
                                                    Document BAR Recon AD A sudah ada pada {this.state.ALERT.data.share_bar_a == 1 ? mHelper.CONVERT_CURRENTTIMES(parseInt(this.state.ALERT.data.at_share_bar_a)) : ""} harap segera lakukan pengecekan.
                                                </div> : ""
                                            }
                                            {
                                                this.state.ALERT.data.share_bar_b  != 0 ? 
                                                <div style={{fontSize:"12px",textAlign:"left"}}>
                                                    Document BAR Recon AD B sudah ada pada {this.state.ALERT.data.share_bar_b == 1 ? mHelper.CONVERT_CURRENTTIMES(parseInt(this.state.ALERT.data.at_share_bar_b)) : ""} harap segera lakukan pengecekan.
                                                </div> : ""
                                            }
                                            {
                                                this.state.ALERT.data.share_fp != 0 ? 
                                                <div style={{fontSize:"12px",textAlign:"left"}}>
                                                    Document Faktur Pajak sudah ada pada {this.state.ALERT.data.share_fp == 1 ? mHelper.CONVERT_CURRENTTIMES(parseInt(this.state.ALERT.data.at_share_fp)) : ""} harap segera lakukan pengecekan.
                                                </div> : ""
                                            }
                                            {
                                                this.state.ALERT.data.share_bukpot != 0 ? 
                                                <div style={{fontSize:"12px",textAlign:"left"}}>
                                                    Document Bukti Potong sudah ada pada {this.state.ALERT.data.share_bukpot == 1 ? mHelper.CONVERT_CURRENTTIMES(parseInt(this.state.ALERT.data.at_share_bukpot)) : ""} harap segera lakukan pengecekan.
                                                </div> : ""
                                            }
                                            {
                                                this.state.ALERT.data.share_inv != 0 ? 
                                                <div style={{fontSize:"12px",textAlign:"left"}}>
                                                    Document Paid Invoice sudah ada pada {this.state.ALERT.data.share_inv == 1 ? mHelper.CONVERT_CURRENTTIMES(parseInt(this.state.ALERT.data.at_share_inv)) : ""} harap segera lakukan pengecekan.
                                                </div> : ""
                                            }
                                            {
                                                this.state.ALERT.data.share_inv_sign != 0 ? 
                                                <div style={{fontSize:"12px",textAlign:"left"}}>
                                                    Document Invoice After Sign sudah ada pada {this.state.ALERT.data.share_inv_sign == 1 ? mHelper.CONVERT_CURRENTTIMES(parseInt(this.state.ALERT.data.at_share_inv_sign)) : ""} harap segera lakukan pengecekan.
                                                </div> : ""
                                            }
                                            {
                                                this.state.FPJP_NOTA_NOTE.count != 0 ?
                                                this.state.FPJP_NOTA_NOTE.raw.map((item,index)=>{
                                                    return (
                                                        <div style={{fontSize:"12px",textAlign:"left"}}>
                                                            Note untuk document transaksi nota debit yang dikirim untuk periode {item.periode} : <b>{item.fpjp_note}</b>
                                                        </div>
                                                    )
                                                })
                                                : ""
                                            }

                                            {
                                                this.state.FPJP_INVOICE_NOTE.count != 0 ?
                                                this.state.FPJP_INVOICE_NOTE.raw.map((item,index)=>{
                                                    return (
                                                        <div style={{fontSize:"12px",textAlign:"left"}}>
                                                            Note untuk document transaksi invoice yang dikirim untuk periode {item.periode} : <b>{item.fpjp_note}</b>
                                                        </div>
                                                    )
                                                })
                                                : ""
                                            }
                                       </div> : <Empty></Empty> }
                                       
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row>
                </Spin>
            </div>
        )
    }
}


export default Dashboard;
